import { render, staticRenderFns } from "./qrcode.vue?vue&type=template&id=2367063c&scoped=true"
import script from "./qrcode.vue?vue&type=script&lang=js"
export * from "./qrcode.vue?vue&type=script&lang=js"
import style0 from "./qrcode.vue?vue&type=style&index=0&id=2367063c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2367063c",
  null
  
)

export default component.exports